export const STATUS_COLORS = {
  Filled: 'success',
  Pending: 'warning',
  Cancelled: 'danger',
  Rejected: 'danger',
};

export const DIRECTION_COLORS = {
  Buy: 'text-red-500',
  Sell: 'text-blue-500',
  Long: 'text-red-500',
  Short: 'text-blue-500',
};

export const LOG_LEVEL_COLORS = {
  INFO: 'text-white',
  WARNING: 'text-yellow-500',
  ERROR: 'text-red-500',
};

export const DATE_FILTERS = [
  { label: '오늘', value: 'today' },
  { label: '1주일', value: '1week' },
  { label: '1개월', value: '1month' },
  { label: '3개월', value: '3month' },
  { label: '전체', value: 'all' },
];

export const STATUS_FILTERS = [
  { label: '전체', value: 'all' },
  { label: '대기', value: 'Pending' },
  { label: '체결', value: 'Filled' },
  { label: '취소', value: 'Cancelled' },
  { label: '거부', value: 'Rejected' },
];

export const CONTRACT_SIZE = 500000; // 코스피200 선물 계약단위
